<template>
  <div>
    <el-card>
      <el-form size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="6">
            <!--发车转运中心-->
            <el-form-item :label="$t('routes.departureTransferCenter')">
              <el-select
                v-model="queryForm.params.startTransitId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in flowDirectNextList"
                  :key="item.siteId"
                  :label="item.siteName"
                  :value="item.siteId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--下一站流向-->
            <el-form-item :label="$t('routes.下一站流向')">
              <el-select
                v-model="queryForm.params.nextId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in flowDirectNextList"
                  :key="item.siteId"
                  :label="item.siteName"
                  :value="item.siteId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div style="margin-top: 27px;">
              <el-button size="small" type="primary" @click="getTableData">{{ $t('collectionCenter.search') }}</el-button>
              <el-button size="small" plain @click="resetSearch">{{ $t('collectionCenter.reset') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div style="margin-bottom: 10px;">
        <el-button
          v-permit:remove="'but:basicData:ManagementMailingRules:add'"
          size="small"
          type="primary"
          @click="openAddEditWindow(1)"
        >
          {{ $t('GlobalSetObj.add') }}
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="exportData"
        >
          {{ $t('collectionCenter.export') }}
        </el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background:'#f2f2f2',color:'black', textAlign:'center' }"
        >
          <el-table-column
            :label="$t('GlobalSetObj.serial')"
            align="center"
            type="index"
            width="80"
            fixed="left"
          />
          <el-table-column
            v-for="(item, index) in tableColumn"
            :key="index"
            :label="item.label"
            :prop="item.prop"
            :align="item.align"
            :min-width="item.width"
          />
          <el-table-column :label="$t('GlobalSetObj.operate')" align="center" fixed="right">
            <template slot-scope="scope">
              <!--编辑-->
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('GlobalSetObj.edit')"
                placement="top"
              >
                <el-button
                  v-permit:remove="'but:basicData:ManagementMailingRules:edit'"
                  size="mini"
                  type="text"
                  @click="openAddEditWindow(2, scope.row)"
                >
                  <i class="el-icon-edit-outline" style="font-size: 20px;margin-right: 10px;" />
                </el-button>
              </el-tooltip>
              <!--删除-->
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('GlobalSetObj.Delete')"
                placement="top"
              >
                <el-popconfirm
                  v-permit:remove="'but:basicData:ManagementMailingRules:delete'"
                  :title="$t('basicData.AreYouSureYouWantToDelete')"
                  @confirm="handleDel(scope.row)"
                >
                  <el-button
                    slot="reference"
                    size="mini"
                    type="text"
                  >
                    <i class="el-icon-delete" style="font-size: 20px" />
                  </el-button>
                </el-popconfirm>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 50, 100, 200, 400]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 20px 0; text-align: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
    <el-drawer
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="editType === 1 ? $t('routes.AddNewRulesForItemsToBeSent') : $t('routes.EditRulesForItemsToBeSent')"
      :visible.sync="isAddEditWindow"
      direction="ltr"
      size="800px"
    >
      <div style="height: calc(100vh - 130px);overflow-y: auto">
        <addEdit
          ref="addEditWindow"
          :key="addEditWindowKey"
          :edit-type="editType"
          :edit-row="editRow"
          @operateUpdate="operateUpdate"
        />
      </div>
      <div style="text-align: right;padding: 10px;border-top: 1px solid #ccc">
        <el-button size="small" @click="isAddEditWindow = false">{{ $t('GlobalSetObj.Cancelar') }}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="confirmChange"
        >
          {{ $t('GlobalSetObj.Salve') }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// import { getSiteTransfer } from '@/api/orderApi';
import { getSiteAndTransfer } from '@/api/newExpressAPI';
import addEdit from './cmp/addEdit.vue';
import { deleteShipmentsRule, exportShipmentsRule, shipmentsRulePageQuery } from '@/api/managementMailingRules';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'ManagementMailingRules',
  components: {
    addEdit
  },
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          startTransitId: '',
          nextId: ''
        }
      },
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      // transferList: [],
      tableData: [],
      tableColumn: [
        // 流向名称
        { label: this.$t('routes.flowName'), prop: 'flowName', align: 'center', width: '150' },
        // 发车转运中心
        { label: this.$t('routes.departureTransferCenter'), prop: 'startTransitName', align: 'center', width: '150' },
        // 下一站流向
        { label: this.$t('routes.下一站流向'), prop: 'nextName', align: 'center', width: '150' },
        // 发车时间
        { label: this.$t('routes.发车时间'), prop: 'departTimeStr', align: 'center', width: '150' },
        // 发车件时间范围
        { label: this.$t('routes.DepartureTimeRange'), prop: 'shipmentsTimeRealm', align: 'center', width: '300' },
        // 最新操作人
        { label: this.$t('customerManagements.newOptioner'), prop: 'updateUserName', align: 'center', width: '150' },
        // 最新修改时间
        { label: this.$t('GlobalSetObj.LastModified'), prop: 'updateTime', align: 'center', width: '150' }
      ],
      total: 0,
      isAddEditWindow: false,
      editType: 1,
      flowDirectNextList: [],
      editRow: null,
      addEditWindowKey: new Date().getTime()
    };
  },
  created() {
    // this.getSiteTransfer();
    this.getTableData();
    this.getFlowDirectNameList();
  },
  methods: {
    // 更新数据
    operateUpdate() {
      this.isAddEditWindow = false;
      this.getTableData();
    },
    // 导出
    exportData() {
      const params = this.getQueryParams().params;
      console.log(params, '====params');
      exportShipmentsRule(params).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 保存编辑
    confirmChange() {
      this.$refs.addEditWindow.confirmAddEdit();
    },
    // 获取下一站流向名称
    getFlowDirectNameList() {
      getSiteAndTransfer().then((res) => {
        if (res.code === 200) {
          this.flowDirectNextList = res.data;
        }
      });
    },
    // 打开新增编辑弹窗
    openAddEditWindow(type, row) {
      this.editType = type;
      this.isAddEditWindow = true;
      if (type === 2) {
        this.editRow = row;
      } else {
        this.editRow = null;
      }
      this.addEditWindowKey = new Date().getTime();
    },
    // 删除
    handleDel(data) {
      deleteShipmentsRule(data.id).then(res => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: this.$t('collectionCenter.DeleteSuccessful') // '删除成功'
          });
          this.getTableData();
        }
      });
    },
    // // 获取转运中心
    // getSiteTransfer() {
    //   getSiteTransfer().then((res) => {
    //     if (res.code === 200) {
    //       this.transferList = res.data;
    //     }
    //   });
    // },
    // 请求参数整理
    getQueryParams() {
      const { pageNumber, pageSize, params } = this.queryForm;
      const queryParams = {
        pageNumber,
        pageSize,
        params: {
          startTransitId: params.startTransitId,
          nextId: params.nextId
        }
      };
      return queryParams;
    },
    // 获取列表数据
    getTableData() {
      const params = this.getQueryParams();
      shipmentsRulePageQuery(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 重置搜索条件
    resetSearch() {
      this.queryForm.params = {
        startTransitId: '',
        nextId: ''
      };
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 翻页
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    }
  }
};
</script>

<style scoped>

</style>
